export function getUTCHtmlId() {
    return 'id-' + Date.now() + '';
}
